import invariant from 'react-utils/invariant';
export default (({
  __adapters,
  fetch,
  getFetcherFromProps,
  isAssetFamilySupported,
  updater
}) => {
  invariant(typeof fetch === 'function', 'fetch is a required function for DSAdapters');
  invariant(typeof getFetcherFromProps === 'function', 'getFetcherFromProps is a required function for DSAdapters');
  invariant(typeof isAssetFamilySupported === 'function', 'isAssetFamilySupported is a required function for DSAdapters');
  invariant(typeof updater === 'function', 'updater is a required function for DSAdapters');
  return {
    __adapters,
    fetch,
    getFetcherFromProps,
    isAssetFamilySupported,
    updater
  };
});